var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.containerEl,{ref:_vm.ref,tag:"component",class:[
    _vm.className,
    _vm.themeClassName
  ],attrs:{"title":_vm.linkTitle,"href":_vm.linkUrl}},[_c('img-banner',{class:_vm.imgConClassName,attrs:{"img-alt":_vm.imgAlt,"bg-image":_vm.bgImage,"mobile-bg-image":_vm.mobileBgImage}}),_c('div',{class:[
      _vm.textConClassName,
      _vm.textAlignClassName,
      _vm.mobileTextAlignClassName,
      _vm.mobileTextPositionClassName ]},[(_vm.hasText)?_c('h2',{class:[
        _vm.textClassName ],style:(_vm.textStyles)},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e(),(_vm.hasButtonText)?_c('p',{class:[
        _vm.buttonTextClassName
      ],style:(_vm.textButtonStyles)},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }